// extracted by mini-css-extract-plugin
export default {"container":"HbQFE","title":"T2WHx","wrapper":"FZguB","additional-wrapper":"QHjZk","button":"a9Acb"};